import { _ } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { zIndices as L } from "@ucl/shared-component-foundations";
import { c as d } from "./index-8b07dec9.js";
import { useCallback as T, useRef as O, useEffect as F } from "react";
import { createPortal as E } from "react-dom";
import "./es.object.keys-9d66766f.js";
import { usePopoverIndex as R } from "./usePopoverIndex.js";
import { useClient as S } from "./useClient.js";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as K } from "./getMetrics-953aa4f8.js";
import "./web.set-timeout-72b6430f.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import { useSlots as x } from "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import { Disclosures as U } from "./disclosure.js";
import { FocusTrap as V } from "./focusTrap.js";
import u, { css as v } from "styled-components";
import { CloseButton as G } from "./closeButton.js";
import { m as J, A as Q } from "./index-55eee02a.js";
import { jsx as a, jsxs as H } from "react/jsx-runtime";
import { getAriaProps as X } from "./aria.js";
import { useFCAnalytics as Y } from "./hooks_internal.js";
import { ComponentAnalyticsDefinitions as A } from "./analytics.js";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./isClient-2f5bedbd.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./es.array.find-index-cbf7640b.js";
import "./es.array.from-fe752fa6.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./es.array.index-of-084b82ab.js";
import "./es.string.iterator-5de8a61e.js";
import "./combineRefs-c9ad2c39.js";
import "./useOnClickOutside.js";
import "./iconButton.js";
import "./button.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "@ucl/shared-icons";
import "./tslib.es6-59e1c9d8.js";
var Z = /* @__PURE__ */ u.div.withConfig({
  displayName: "modalWindowstyles__ContainerWrapper",
  componentId: "sc-11sw2qz-0"
})(["&.ModalWindow__container-wrapper{", ";}"], function(e) {
  var o = e.theme.components.modalWindow;
  return v(o.ModalContainerWrapper);
}), oo = /* @__PURE__ */ u(J.div).withConfig({
  displayName: "modalWindowstyles__Container",
  componentId: "sc-11sw2qz-1"
})(["&.ModalWindow__container{", ";}"], function(e) {
  var o = e.theme, n = o.components.modalWindow, t = o.componentStyles;
  return v(n.ModalContainer, t);
}), eo = /* @__PURE__ */ u.div.withConfig({
  displayName: "modalWindowstyles__Content",
  componentId: "sc-11sw2qz-2"
})(["&.ModalWindow__content{", ";}"], function(e) {
  var o = e.theme.components.modalWindow;
  return v(o.ModalContent);
}), no = /* @__PURE__ */ u.header.withConfig({
  displayName: "modalWindowstyles__Header",
  componentId: "sc-11sw2qz-3"
})(["&.ModalWindow__header{", ";}"], function(e) {
  var o = e.theme.components.modalWindow;
  return v(o.ModalHeader);
}), to = /* @__PURE__ */ u.h1.withConfig({
  displayName: "modalWindowstyles__Title",
  componentId: "sc-11sw2qz-4"
})(["&.ModalWindow__title{", ";}"], function(e) {
  var o = e.theme.components.modalWindow;
  return v(o.ModalTitle);
}), io = /* @__PURE__ */ u.div.withConfig({
  displayName: "modalWindowstyles__Body",
  componentId: "sc-11sw2qz-5"
})(["&.ModalWindow__body{", ";}"], function(e) {
  var o = e.theme.components.modalWindow;
  return v(o.ModalBody);
}), ro = /* @__PURE__ */ u.footer.withConfig({
  displayName: "modalWindowstyles__Footer",
  componentId: "sc-11sw2qz-6"
})(["&.ModalWindow__footer{", ";}"], function(e) {
  var o = e.theme.components.modalWindow, n = e.$style;
  return v(o.ModalFooterWrapper, n);
}), $ = /* @__PURE__ */ u(G).withConfig({
  displayName: "modalWindowstyles__CloseButton",
  componentId: "sc-11sw2qz-7"
})(["&.ModalWindow__close{", ";}"], function(e) {
  var o = e.theme.components.modalWindow;
  return v(o.ModalCloseButton);
}), ao = ["children", "className"], lo = function(o) {
  var n = o.children, t = o.className, i = _(o, ao);
  return /* @__PURE__ */ a(io, Object.assign({
    "data-id": "modal-body"
  }, i, {
    className: d([t, "ModalWindow__body"]),
    children: n
  }));
}, so = ["children", "placement", "className"], mo = function(o) {
  var n = o.children, t = o.placement, i = o.className, l = _(o, so);
  return /* @__PURE__ */ a(ro, Object.assign({}, l, {
    $style: {
      justifyContent: t
    },
    className: d(["ModalWindow__footer", i]),
    children: n
  }));
}, co = ["children", "onClose", "hasClose", "id", "headingLevel", "idProps", "accessibilityOptions", "className"], P = function(o) {
  var n, t, i, l = o.children, s = o.onClose, C = o.hasClose, y = C === void 0 ? !0 : C, W = o.id, m = o.headingLevel, r = m === void 0 ? "h2" : m, f = o.idProps, M = o.accessibilityOptions, b = o.className, g = _(o, co), c = x(l, {
    CloseButton: P.CloseButton
  }, x.PickType.LAST), p = T(function(N) {
    var w;
    s == null || s(), (w = c.CloseButton) == null || (w = w.props) == null || w.onClick == null || w.onClick(N);
  }, [s, (n = c.CloseButton) == null ? void 0 : n.props]);
  return /* @__PURE__ */ H(no, Object.assign({}, g, {
    className: d(["ModalWindow__header", b]),
    children: [c.rest.length > 0 && /* @__PURE__ */ a(to, {
      id: W,
      as: r,
      className: d(["ModalWindow__title"]),
      children: c.rest
    }), y && /* @__PURE__ */ a($, Object.assign({
      id: f == null ? void 0 : f.closeButtonId,
      size: "large"
    }, X("button", M), (t = c.CloseButton) == null ? void 0 : t.props, {
      onClick: p,
      className: d(["ModalWindow__close", (i = c.CloseButton) == null ? void 0 : i.props.className]),
      children: y && /* @__PURE__ */ a($, {})
    }))]
  }));
};
P.CloseButton = function(e) {
  return /* @__PURE__ */ a($, Object.assign({}, e));
};
var po = function(o, n, t) {
  var i = O(!0), l = O(!0), s = Y(n, t);
  F(function() {
    if (l.current) {
      l.current = !1;
      return;
    }
    o ? (s(A.MODAL, Object.assign({
      modalViewCounter: 1,
      modalOpen: i.current ? 1 : void 0
    }, n, t)), i.current = !1) : s(A.MODAL, Object.assign({
      modalClose: 1
    }, n, t));
  }, [o, s]);
}, uo = ["isOpen", "onClose", "variant", "children", "bgOverlayColor", "backdropProps", "disclosures", "className", "platformAnalyticsData", "runtimeAnalyticsData", "disablePortal"], h = function(o) {
  var n = o.isOpen, t = o.onClose, i = o.variant, l = i === void 0 ? "medium" : i, s = o.children, C = o.bgOverlayColor, y = C === void 0 ? "#0000004c" : C, W = o.backdropProps, m = W === void 0 ? {
    style: {
      background: y
    }
  } : W, r = o.disclosures, f = o.className, M = o.platformAnalyticsData, b = o.runtimeAnalyticsData, g = o.disablePortal, c = _(o, uo);
  po(n, M, b);
  var p = S(), N = K({
    label: "ModalWindow"
  }), w = R(n, h.zIndex), k = O(null), q = function(B) {
    B.code === "Escape" && (t == null || t());
  };
  if (F(function() {
    if (p.isClient)
      return p.document.body.style.overflow = n ? "hidden" : "", function() {
        p.document.body.style.overflow = "";
      };
  }, [n, p]), !p.isClient)
    return null;
  var D = function(B) {
    var z;
    (z = k.current) != null && z.contains(B.target) || t == null || t();
  }, j = function() {
    return /* @__PURE__ */ a(Q, {
      children: n && /* @__PURE__ */ a(Z, Object.assign({}, m, {
        onClick: D,
        className: d(["ModalWindow__container-wrapper", "ModalWindow__container-wrapper--" + l, m == null ? void 0 : m.className]),
        style: Object.assign({
          background: y,
          zIndex: w
        }, m == null ? void 0 : m.style),
        children: /* @__PURE__ */ a(V, {
          open: !0,
          disableEnforceFocus: !0,
          children: /* @__PURE__ */ a(oo, Object.assign({
            ref: k,
            role: "dialog",
            initial: "closed",
            animate: n ? "open" : "closed",
            exit: "closed",
            transition: {
              duration: 0.3
            },
            variants: {
              closed: {
                opacity: 0
              },
              open: {
                opacity: 1
              }
            },
            onKeyUp: q
          }, N, c, {
            className: d(["ModalWindow__container", "ModalWindow__container--" + l, f]),
            children: /* @__PURE__ */ H(eo, {
              className: d(["ModalWindow__content", "ModalWindow__content--" + l]),
              children: [s, r && /* @__PURE__ */ a(U, {
                disclosureContent: r == null ? void 0 : r.disclosureContent,
                id: r == null ? void 0 : r.id,
                className: d(["ModalWindow__disclosure", r == null ? void 0 : r.className]),
                disclosureTitleColor: r == null ? void 0 : r.disclosureTitleColor
              })]
            })
          }))
        })
      }))
    });
  };
  return g ? j() : /* @__PURE__ */ E(j(), p.document.body);
};
h.zIndex = L.modal;
h.Header = P;
h.Body = lo;
h.Footer = mo;
export {
  lo as ModalBody,
  mo as ModalFooter,
  P as ModalHeader,
  h as ModalWindow
};
